(function () {
  var THUMB_W = 88;
  var INTERVAL = 5000;

  function hard(el, prop, val) { el.style.setProperty(prop, val, 'important'); }

  function applyLayout() {
    var mg = document.querySelector('.product__media-wrapper media-gallery[data-desktop-layout="thumbnail"]');
    if (!mg) return;
    var desktop = window.matchMedia('(min-width: 990px)').matches;
    var slider = mg.querySelector('.product__media-list');
    var items = mg.querySelectorAll('.product__media-item');

    if (!desktop) return;

    hard(mg, 'display', 'grid');
    hard(mg, 'grid-template-columns', THUMB_W + 'px minmax(0, 1fr)');
    hard(mg, 'gap', '12px');
    hard(mg, 'align-items', 'start');

    var th = mg.querySelector('.thumbnail-slider');
    if (th) {
      hard(th, 'grid-column', '1');
      hard(th, 'grid-row', '1');
      hard(th, 'display', 'flex');
      hard(th, 'flex-direction', 'column');
      hard(th, 'width', THUMB_W + 'px');
      hard(th, 'max-width', THUMB_W + 'px');
      hard(th, 'margin', '0');
      hard(th, 'overflow', 'visible');
      hard(th, 'align-items', 'stretch');

      var tl = th.querySelector('.thumbnail-list');
      if (tl) {
        hard(tl, 'display', 'flex');
        hard(tl, 'flex-direction', 'column');
        hard(tl, 'flex-wrap', 'nowrap');
        hard(tl, 'gap', '8px');
        hard(tl, 'overflow-y', 'auto');
        hard(tl, 'overflow-x', 'hidden');
        hard(tl, 'max-height', '70vh');
        hard(tl, 'width', '100%');
        hard(tl, 'margin', '0');
        hard(tl, 'padding', '0');
        hard(tl, 'transform', 'none');
        hard(tl, 'scroll-snap-type', 'none');
        tl.querySelectorAll('.thumbnail-list__item').forEach(function (li) {
          hard(li, 'width', '100%');
          hard(li, 'min-width', '0');
          hard(li, 'max-width', 'none');
          hard(li, 'flex', '0 0 auto');
          hard(li, 'margin', '0');
          hard(li, 'padding', '0');
          hard(li, 'transform', 'none');
        });
      }
      var btns = th.querySelector('.slider-buttons');
      if (btns) btns.style.display = 'none';
    }

    var vw = mg.querySelector('slider-component.slider-mobile-gutter');
    if (vw) {
      hard(vw, 'grid-column', '2');
      hard(vw, 'grid-row', '1');
      hard(vw, 'margin', '0');
      hard(vw, 'min-width', '0');
      hard(vw, 'width', '100%');
      hard(vw, 'overflow', 'visible');
    }

    if (slider) {
      hard(slider, 'display', 'flex');
      hard(slider, 'flex-wrap', 'nowrap');
      hard(slider, 'overflow-x', 'auto');
      hard(slider, 'overflow-y', 'hidden');
      hard(slider, 'scroll-snap-type', 'x mandatory');
      hard(slider, 'width', '100%');
      hard(slider, 'margin', '0');
      hard(slider, 'padding', '0');
      hard(slider, 'gap', '0');
      hard(slider, 'transform', 'none');
      hard(slider, 'scroll-behavior', 'smooth');
    }
    items.forEach(function (it) {
      hard(it, 'display', 'block');
      hard(it, 'width', '100%');
      hard(it, 'min-width', '100%');
      hard(it, 'max-width', '100%');
      hard(it, 'flex', '0 0 100%');
      hard(it, 'margin', '0');
      hard(it, 'padding', '0');
      hard(it, 'transform', 'none');
      hard(it, 'opacity', '1');
      hard(it, 'visibility', 'visible');
      hard(it, 'scroll-snap-align', 'start');
      it.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--fade-in');
      var c = it.querySelector('.product-media-container, .global-media-settings');
      if (c) { c.style.removeProperty('height'); c.style.removeProperty('max-height'); }
    });
  }

  function startAuto() {
    var mg = document.querySelector('.product__media-wrapper media-gallery[data-desktop-layout="thumbnail"]');
    if (!mg) return;
    var slider = mg.querySelector('.product__media-list');
    if (!slider) return;
    var items = slider.querySelectorAll('.product__media-item');
    if (items.length < 2) return;
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    if (slider.dataset.lhAuto === '1') return;
    slider.dataset.lhAuto = '1';

    var idx = 0, paused = false;
    function go(i) {
      idx = (i + items.length) % items.length;
      var w = slider.getBoundingClientRect().width;
      if (!w) return;
      slider.scrollTo({ left: idx * w, behavior: 'smooth' });
    }
    setInterval(function () {
      if (paused) return;
      applyLayout();
      go(idx + 1);
    }, INTERVAL);
    ['mouseenter', 'touchstart', 'focusin'].forEach(function (e) {
      slider.addEventListener(e, function () { paused = true; }, { passive: true });
    });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (e) {
      slider.addEventListener(e, function () { paused = false; }, { passive: true });
    });
    var t;
    slider.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = slider.getBoundingClientRect().width;
        if (w) idx = Math.round(slider.scrollLeft / w);
      }, 150);
    }, { passive: true });
    mg.querySelectorAll('.thumbnail-list__item').forEach(function (th, i) {
      th.addEventListener('click', function () {
        idx = i;
        setTimeout(applyLayout, 120);
      });
    });
  }

  function boot() {
    applyLayout();
    setTimeout(applyLayout, 150);
    setTimeout(applyLayout, 700);
    setTimeout(applyLayout, 1800);
    startAuto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  window.addEventListener('resize', applyLayout);
  document.addEventListener('shopify:section:load', boot);
})();
